import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import classNames from 'classnames'
import _ from 'lodash'
import { formatAmount, T } from 'ziphy-web-shared/basic/helpers'
import { Button } from 'ziphy-web-shared/basic/lib/buttons'
import { Badge } from 'ziphy-web-shared/basic/lib/simple'
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals'

import { $booking } from '@store'

import PatientGroupTypes from '../patientGroupTypes/PatientGroupTypes'
import styles from './ServiceInfo.modal.module.scss'

const ServiceInfoModal = ({ serviceId, onBook, _core }) => {
  const { t } = useTranslation()
  const service = $booking.$services.getServiceById(serviceId)

  const preparedPrices = useMemo(() => {
    let result = []

    let items = _.filter(
      $booking.practiceServices,
      (x) => x.serviceId === serviceId && $booking.availablePracticeIds.includes(x.practiceId),
    )
    if (!items.length) return result

    items = _.orderBy(_.uniqBy(items, 'price'), 'price', 'asc')

    if (items.length > 1) {
      result = [_.head(items), _.last(items)]
    } else {
      result = [_.head(items)]
    }

    return result.map((x, i) => {
      // add currency only for last value
      if (i === result.length - 1) {
        return formatAmount(x.price, x.currency)
      }
      return formatAmount(x.price, '')
    })
  }, [serviceId])

  return (
    <Modal centered scrollable size={'lg'}>
      <div className="modal-toolbar">
        <ModalToolbarBtn type="close" action={_core.onHide} />
      </div>
      <Modal.Header titleClassName="title-md">{service.name}</Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.badgesContainer}>
          <PatientGroupTypes service={service} mode="lg" />
          <Badge mode={['secondary-gray', 'lg', 'rounded']}>{preparedPrices.join(' - ')}</Badge>
        </div>
        <div className={styles.description}>
          <T className="max_width--lg text-pre-line">{service.description}</T>
        </div>
        <div className={classNames(styles.buttons, 'mt-30')}>
          <Button mode="primary" disabled={service.disabled} onClick={(e) => onBook(e, service.id)}>
            {t('btn.book_appointment')}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ServiceInfoModal
